import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/vsts/work/1/s/adminportal/node_modules/@ant-design/nextjs-registry/es/AntdRegistry.js");
;
import(/* webpackMode: "eager" */ "/home/vsts/work/1/s/adminportal/node_modules/next-navigation-guard/dist/components/NavigationGuardProvider.js");
;
import(/* webpackMode: "eager" */ "/home/vsts/work/1/s/adminportal/node_modules/next-navigation-guard/dist/components/NavigationGuardProviderContext.js");
;
import(/* webpackMode: "eager", webpackExports: ["AppProvider"] */ "/home/vsts/work/1/s/adminportal/src/app/app-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DynamicFavicon"] */ "/home/vsts/work/1/s/adminportal/src/components/DynamicFavicon.tsx");
